'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { CallCenterContentLayout } from '../CallCenterContentLayout.js';
import { ActionItem } from '../../slots/ActionItem/ActionItem.js';
import { PrimaryPhone } from '../../slots/PrimaryPhone/PrimaryPhone.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ActionLayout = function(props) {
    var items = props.items, primaryPhone = props.primaryPhone, onActionItemClick = props.onActionItemClick, tmp = props.renderActionItem, ActionItemComponent = tmp === void 0 ? ActionItem : tmp, tmp1 = props.renderPrimaryPhone, PrimaryPhoneComponent = tmp1 === void 0 ? PrimaryPhone : tmp1, onPrimaryPhoneLinkClick = props.onPrimaryPhoneLinkClick;
    return /*#__PURE__*/ jsx(CallCenterContentLayout, {
        primary: primaryPhone ? /*#__PURE__*/ jsx(PrimaryPhoneComponent, _extends({
            onClick: function(event) {
                return onPrimaryPhoneLinkClick == null ? void 0 : onPrimaryPhoneLinkClick(primaryPhone, event);
            }
        }, primaryPhone)) : null,
        itemsSpacing: 8,
        spacing: 24,
        children: items.map(function(_param)  {
            var id = _param.id, item = _object_without_properties_loose(_param, [
                "id"
            ]);
            return jsx(ActionItemComponent, _extends({
                onClick: function(event) {
                    return onActionItemClick == null ? void 0 : onActionItemClick(_extends({
                        id: id
                    }, item), event);
                }
            }, item), id);
        })
    });
};

export { ActionLayout };
